'use client';
var classes = {"root":"m-a513464","icon":"m-a4ceffb","loader":"m-b0920b15","body":"m-a49ed24","title":"m-3feedf16","description":"m-3d733a3a","closeButton":"m-919a4d88"};

export { classes as default };
//# sourceMappingURL=Notification.module.css.mjs.map
